<div class="broker-plan-payment-failed position-relative pad-32-bottom">
    <div class="position-absolute  cursor-pointer close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </div>
    <div class="avatar flex-centered-container">
        <img src="/assets/icons/logo-compact.png">
    </div>
    <div class="flex-centered-container margin-8-bottom">
        <mat-icon class="text-negative margin-4-right">
            cancel_rounded
        </mat-icon>
        <h2 class="font-18">
            Payment Failed
        </h2>
    </div>
    <div class="font-14 margin-auto text-center policies-text padding-bottom">
        <div class="margin-8-bottom">
            Your plan has expired because the autopayment was unsuccessful due to insufficient funds in your bank account at the time of deduction.
        </div>
        <div>
            Kindly maintain sufficient balance and subscribe again.
        </div>

    </div>
    <mat-divider class="mat-divider width-90 margin-auto"></mat-divider>
    <div class="padding-hr width-70 margin-auto padding-top">
        <div class="font-14 flex-space-between margin-8-bottom">
            <span class="policies-text">Plan</span>
            <span>{{currentPlan}}</span>
        </div>
        <div class="font-14 flex-space-between margin-8-bottom">
            <span class="policies-text">Required funds</span>
            <span>{{CURRENCY_LABEL}} {{requiredFunds | precision: DEFAULT_PRECISION
                | nullCheck}}</span>
        </div>
        <!-- <div *ngIf="isShareIndia" class="font-14 flex-space-between margin-8-bottom">
            <span class="policies-text">Available funds</span>
            <span>{{CURRENCY_LABEL}} {{availableFunds | earningsFormatter: true: DEFAULT_PRECISION
                | nullCheck}}</span>
        </div> -->
    </div>
    <div class="center-label align-items-center margin-24-top">
        <button mat-flat-button [tabIndex]="-1" color="accent" class="ut-pro-button width-70 gradient" (click)="redirectToPlans()">
            Subscribe Again
        </button>
        <!-- <div class="cursor-pointer text-accent font-14 margin-top" (click)="redirectToFunds()">
            +Add Funds
        </div> -->
    </div>
</div>